<template>
  <div>
    <b-form-input
      v-model="currentAnswer"
      class="bg-white"
      type="tel"
      :state="validateState"
      :maxlength="maxLength"
      :placeholder="$t('qrcode-get-coupon.verification.verification-code-validate.require')"
    >
    </b-form-input>
    <b-form-invalid-feedback class="w-100 invalid-feedback d-block" v-if="validateState === false">{{errorMessage}}</b-form-invalid-feedback>
  </div>
</template>

<script>

export default {
  data() {
    return {
      validateState: undefined,
      currentAnswer: '',
    };
  },
  methods: {
    showErrorMessage(message) {
      this.currentAnswer = '';
      this.validateState = false;
      this.errorMessage = message;
    },
  },
  props: {
    maxLength: {
      type: Number,
    },
  },
  watch: {
    currentAnswer() {
      this.$nextTick(() => {
        this.currentAnswer = this.currentAnswer.replace(/[^0-9]/g, '');
      });
      if (this.currentAnswer.length >= 1) {
        this.validateState = undefined;
      }
      if (this.currentAnswer.length === this.maxLength) {
        this.$emit('checkVerify', this.currentAnswer);
      }
    },
  },
};
</script>
